<div class="container-fluid p-3">
  <!-- Banner Section -->
  <div class="row justify-content-center mb-4">
    <div class="col-12 col-md-8 text-center">
      <div class="card shadow-sm">
        <img
          src="https://cdn.grabon.in/gograbon/images/festival/1611313853284.jpg"
          alt="Festival Banner"
          class="img-fluid rounded-top"
        />
      </div>
    </div>
  </div>

  <!-- Scratch & Win Title -->
  <div class="row justify-content-center mb-4">
    <div class="col-12 text-center">
      <h2 class="fw-bold text-primary">Scratch & Win!</h2>
      <p class="lead text-muted">Uncover amazing offers by scratching the cards below.</p>
    </div>
  </div>

  <!-- Scratch Cards Grid -->
  <div class="row g-3 justify-content-center">

    <div *ngIf= "offers.length == 0" class="row m-0 mt-2">
      <div class="col-md-12 text-center">
        <div class=" p-3">
          <h2 class="bouncing-text text-danger">Purchase now, to avail exciting offers !!</h2>
        </div>
      </div>
    </div>



    <div
      class=" col-sm-6 col-md-4 col-lg-3"
      *ngFor="let offer of offers; let i = index"
    >


      <div
        class="card shadow-sm h-100"
        [ngClass]="{
          'border-danger': offer.expired,
          'border-success': offer.scratched && !offer.expired
        }"
      >
        <div class="card-body p-0 position-relative">

          <!-- Scratch Card Canvas -->
          <div
            #card
            class="scratch-card position-relative"
            [ngStyle]="{
              'background-image': offer.backgroundImage,
              'display': 'block'

            }"
          ></div>

          <!-- Expired Label -->
          <div *ngIf="offer.expired" class="expired-label bg-danger text-white p-2 text-center">
            Expired
          </div>

          <!-- Offer Details (Visible after scratching) -->
          <div
            *ngIf="offer.scratched"
            class="offer-details p-2 text-center"
            [ngClass]="{
              'bg-success': !offer.expired,
              'bg-danger': offer.expired
            }"
          >
            <strong class="text-white z-3">{{ offer.offerName }}</strong>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
